import React from 'react';
import transparentLogo from '../../assets/logos/transparent.png';
import textLogo from '../../assets/logos/Pink-Flamingo-Logo---Text---White-BG.png';
import fullLogo from '../../assets/logos/Pink-Flamingo-Logo---Full-White-BG.png';

// Main PFI Logo - Uses the transparent background version (most versatile)
export const PFIFullLogo = ({ size = 'md', className = '' }) => {
  const sizeClasses = {
    sm: 'h-8',
    md: 'h-12',
    lg: 'h-16',
    xl: 'h-24',
    '2xl': 'h-32'
  };

  return (
    <img 
      src={transparentLogo}
      alt="Pink Flamingo Interiors"
      className={`${sizeClasses[size]} w-auto object-contain ${className}`}
    />
  );
};

// Text-only version for compact spaces
export const PFITextLogo = ({ size = 'md', className = '' }) => {
  const sizeClasses = {
    sm: 'h-6',
    md: 'h-8',
    lg: 'h-10',
    xl: 'h-12',
    '2xl': 'h-16'
  };

  return (
    <img 
      src={textLogo}
      alt="Pink Flamingo Interiors"
      className={`${sizeClasses[size]} w-auto object-contain ${className}`}
    />
  );
};

// White background version for specific use cases
export const PFILogoWhiteBG = ({ size = 'md', className = '' }) => {
  const sizeClasses = {
    sm: 'h-8',
    md: 'h-12',
    lg: 'h-16',
    xl: 'h-24',
    '2xl': 'h-32'
  };

  return (
    <img 
      src={fullLogo}
      alt="Pink Flamingo Interiors"
      className={`${sizeClasses[size]} w-auto object-contain ${className}`}
    />
  );
};

export const PFISymbol = ({ size = 'md', className = '' }) => {
  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-12 h-12',
    lg: 'w-16 h-16',
    xl: 'w-24 h-24'
  };

  return (
    <div className={`${sizeClasses[size]} ${className}`}>
      <svg viewBox="0 0 100 100" className="w-full h-full">
        <defs>
          <radialGradient id="symbolBg" cx="50%" cy="30%" r="70%">
            <stop offset="0%" stopColor="#fdf2f8" />
            <stop offset="100%" stopColor="#f3e8ff" />
          </radialGradient>
          <linearGradient id="symbolFlamingo" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#ec4899" />
            <stop offset="100%" stopColor="#f97316" />
          </linearGradient>
        </defs>
        
        <circle cx="50" cy="50" r="45" fill="url(#symbolBg)" opacity="0.9"/>
        <ellipse cx="50" cy="65" rx="18" ry="25" fill="url(#symbolFlamingo)" className="drop-shadow-md"/>
        <path d="M 35 50 Q 30 35 40 25" stroke="url(#symbolFlamingo)" strokeWidth="8" fill="none" strokeLinecap="round"/>
        <circle cx="42" cy="22" r="8" fill="url(#symbolFlamingo)"/>
        <path d="M 38 25 L 32 28 L 38 28 Z" fill="#f97316"/>
        <circle cx="45" cy="20" r="2" fill="white"/>
        <circle cx="46" cy="19" r="1" fill="black"/>
      </svg>
    </div>
  );
};

export const BrandGradient = ({ children, className = '' }) => {
  return (
    <div className={`bg-gradient-to-r from-pink-500 via-pink-400 to-orange-400 ${className}`}>
      {children}
    </div>
  );
};